function hslToRgb(hsl) {
    const h = hsl.h / 360
    const s = hsl.s / 100
    const l = hsl.l / 100

    let r, g, b

    if (s === 0) {
        r = g = b = l // achromatic
    } else {
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1
            if (t > 1) t -= 1
            if (t < 1/6) return p + (q - p) * 6 * t
            if (t < 1/2) return q
            if (t < 2/3) return p + (q - p) * (2/3 - t) * 6
            return p
        }

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s
        const p = 2 * l - q

        r = hue2rgb(p, q, h + 1/3)
        g = hue2rgb(p, q, h)
        b = hue2rgb(p, q, h - 1/3)
    }

    r *= 255
    g *= 255
    b *= 255

    return { r: r, g: g, b: b}
}

function rgbToHsl(rgb) {
    const r = rgb.r / 255
    const g = rgb.g / 255
    const b = rgb.b / 255

    const max = Math.max(r, g, b), min = Math.min(r, g, b)
    let h, s, l = (max + min) / 2

    if (max == min) {
        h = s = 0 // achromatic
    } else {
        const d = max - min
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0)
                break
            case g:
                h = (b - r) / d + 2
                break
            case b:
                h = (r - g) / d + 4
                break
        }

        h /= 6
    }

    h *= 360
    s *= 100
    l *= 100

    return { h: h, s: s, l: l }
}

/**
 * A linear interpolator for hex colors.
 *
 * Based on:
 * https://gist.github.com/rosszurowski/67f04465c424a9bc0dae
 *
 * @param {{r: Number, g: Number, b: Number }} c1
 * @param {{r: Number, g: Number, b: Number }} c2
 * @param {Number} amount  (the amount to fade from a to b)
 *
 * @example
 * // returns 0x7f7f7f
 * lerpColor(0x000000, 0xffffff, 0.5)
 *
 * @returns {{r: Number, g: Number, b: Number }}
 */
export function interpolateColorRBG(c1, c2, amount) {
    const rr = c1.r + amount * (c2.r - c1.r),
        rg = c1.g + amount * (c2.g - c1.g),
        rb = c1.b + amount * (c2.b - c1.b);

    return {r: rr, g: rg, b: rb};
}


/**
 * A linear interpolator for HSL colors.
 *
 * @param {{h: Number, s: Number, l: Number }} c1
 * @param {{h: Number, s: Number, l: Number }} c2
 * @param {Number} amount  (the amount to fade from a to b)
 *
 * @returns {{h: Number, s: Number, l: Number }}
 */
export function interpolateColorHSLA(c1, c2, amount) {
   return rgbToHsl(interpolateColorRBG(hslToRgb(c1), hslToRgb(c2), amount));
}

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

export function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}


/**
 * @return {number|*}
 */
export function getRandomNormal(min, max, skew=1) {
    let u = 0, v = 0;
    while (u === 0) u = Math.random() //Converting [0,1) to (0,1)
    while (v === 0) v = Math.random()
    let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v)

    num = num / 10.0 + 0.5 // Translate to 0 -> 1
    if (num > 1 || num < 0)
        num = getRandomNormal(min, max, skew) // resample between 0 and 1 if out of range

    else {
        num = Math.pow(num, skew) // Skew
        num *= max - min // Stretch to fill range
        num += min // offset to min
    }
    return num
}